export const bookList = {
  "10118": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": []
    }
  },
  "10128": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4646314,
        "gid": 4646314,
        "goodsType": 1,
        "price": 59.0000,
        "discount": 1,
        "discountPrice": 59.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:54",
        "cnIbraryType": "K209",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/EBqUmFo31.jpg",
        "topic": "博物馆里的极简中国史.文明的碎片",
        "title": "博物馆里的极简中国史.文明的碎片",
        "author": "张经纬",
        "isbn": "9787559675545",
        "publisher": "北京联合出版公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4578007,
        "gid": 4578007,
        "goodsType": 1,
        "price": 78.0000,
        "discount": 1,
        "discountPrice": 78.0000,
        "currency": 1,
        "createTime": "2024-08-28 11:59:11",
        "cnIbraryType": "K126",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/mgDbp0ZEW.jpg",
        "topic": "暗黑历史书系·角斗士",
        "title": "暗黑历史书系·角斗士",
        "author": "［英］本·哈伯德",
        "isbn": "9787218167800",
        "publisher": "广东人民出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4464393,
        "gid": 4464393,
        "goodsType": 1,
        "price": 128.0000,
        "discount": 1,
        "discountPrice": 128.0000,
        "currency": 1,
        "createTime": "2024-08-28 13:26:03",
        "cnIbraryType": "K24",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/A4qcP5wPH.jpg",
        "topic": "隋唐：帝国的形成",
        "title": "隋唐：帝国的形成",
        "author": "孙英刚 著",
        "isbn": "9787573207661",
        "publisher": "上海古籍出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4464392,
        "gid": 4464392,
        "goodsType": 1,
        "price": 128.0000,
        "discount": 1,
        "discountPrice": 128.0000,
        "currency": 1,
        "createTime": "2024-08-28 13:26:03",
        "cnIbraryType": "K24",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/AiURaz1Le.jpg",
        "topic": "隋唐：盛衰的痕迹",
        "title": "隋唐：盛衰的痕迹",
        "author": "孙英刚 著",
        "isbn": "9787573207678",
        "publisher": "上海古籍出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4578069,
        "gid": 4578069,
        "goodsType": 1,
        "price": 78.0000,
        "discount": 1,
        "discountPrice": 78.0000,
        "currency": 1,
        "createTime": "2024-08-28 17:17:36",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/YFwOaG1Ll.jpg",
        "topic": "激荡三百年",
        "title": "激荡三百年",
        "author": "艾公子  著",
        "isbn": "9787538774672",
        "publisher": "时代文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4653174,
        "gid": 4653174,
        "goodsType": 1,
        "price": 78.0000,
        "discount": 1,
        "discountPrice": 78.0000,
        "currency": 1,
        "createTime": "2024-08-28 17:17:36",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/wYhGhotj4.jpg",
        "topic": "假如唐朝有朋友圈（上下册）",
        "title": "假如唐朝有朋友圈（上下册）",
        "author": "韩朝辉  著",
        "isbn": "9787538775099",
        "publisher": "时代文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4535864,
        "gid": 4535864,
        "goodsType": 1,
        "price": 158.0000,
        "discount": 1,
        "discountPrice": 158.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:52:03",
        "cnIbraryType": "K225",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/SywfOisuy.jpg",
        "topic": "春秋史话（上下）",
        "title": "春秋史话（上下）",
        "author": "余灵灵",
        "isbn": "9787506891820",
        "publisher": "中国书籍出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4630660,
        "gid": 4630660,
        "goodsType": 1,
        "price": 78.0000,
        "discount": 1,
        "discountPrice": 78.0000,
        "currency": 1,
        "createTime": "2024-08-29 16:15:42",
        "cnIbraryType": "K249",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/x7bJZWQfG.jpg",
        "topic": "九王夺嫡",
        "title": "九王夺嫡",
        "author": "江左辰",
        "isbn": "9787205110055",
        "publisher": "辽宁人民出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10129": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4643698,
        "gid": 4643698,
        "goodsType": 1,
        "price": 59.8000,
        "discount": 1,
        "discountPrice": 59.8000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:51",
        "cnIbraryType": "B848.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/5UvEngzPD.jpg",
        "topic": "逆转开局",
        "title": "逆转开局",
        "author": "丁辉",
        "isbn": "9787516838778",
        "publisher": "台海出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4009697,
        "gid": 4009697,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:52",
        "cnIbraryType": "B848",
        "imageUrl": "http://img1.winxuancdn.com/1949/1203321949_0_1_800x800.jpg?1716970991017",
        "topic": "偏见的本质",
        "title": "偏见的本质",
        "author": "(美) 戈登·奥尔波特著 ; 墨硝, 刘可译",
        "isbn": "9787213105203",
        "publisher": "浙江人民出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4518519,
        "gid": 4518519,
        "goodsType": 1,
        "price": 68.0000,
        "discount": 1,
        "discountPrice": 68.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "B846",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/y5LKh6FHE.jpg",
        "topic": "原来我是孤独症（RMLH）",
        "title": "原来我是孤独症（RMLH）",
        "author": "[澳] 桑德拉·托姆琼斯（Sandra Th",
        "isbn": "9787520737395",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4614114,
        "gid": 4614114,
        "goodsType": 1,
        "price": 39.8000,
        "discount": 1,
        "discountPrice": 39.8000,
        "currency": 1,
        "createTime": "2024-08-28 11:59:12",
        "cnIbraryType": "B84",
        "imageUrl": "http://img0.winxuancdn.com/5304/1203335304_0_1_800x800.jpg?1716773127031",
        "topic": "自我分析",
        "title": "自我分析",
        "author": "[美]卡伦·霍妮",
        "isbn": "9787574901131",
        "publisher": "花城出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4612770,
        "gid": 4612770,
        "goodsType": 1,
        "price": 48.0000,
        "discount": 1,
        "discountPrice": 48.0000,
        "currency": 1,
        "createTime": "2024-08-28 15:35:04",
        "cnIbraryType": "B842",
        "imageUrl": "http://img0.winxuancdn.com/4125/1203334125_0_1_800x800.jpg?1717471609192",
        "topic": "论恐惧",
        "title": "论恐惧",
        "author": "[印]克里希那穆提、Sue",
        "isbn": "9787522526423",
        "publisher": "九州出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4555162,
        "gid": 4555162,
        "goodsType": 1,
        "price": 56.0000,
        "discount": 1,
        "discountPrice": 56.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:19:26",
        "cnIbraryType": "B848.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/oisHwNw2D.jpg",
        "topic": "胜者谋略",
        "title": "胜者谋略",
        "author": "戚风",
        "isbn": "9787554623008",
        "publisher": "古吴轩出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4555118,
        "gid": 4555118,
        "goodsType": 1,
        "price": 56.0000,
        "discount": 1,
        "discountPrice": 56.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:19:26",
        "cnIbraryType": "B848.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/gbLEvOEM5.jpg",
        "topic": "向上借势",
        "title": "向上借势",
        "author": "余檀",
        "isbn": "9787554623015",
        "publisher": "古吴轩出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4555250,
        "gid": 4555250,
        "goodsType": 1,
        "price": 56.0000,
        "discount": 1,
        "discountPrice": 56.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:19:26",
        "cnIbraryType": "B848.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/tXSLc3wZN.jpg",
        "topic": "高手布局",
        "title": "高手布局",
        "author": "羽林",
        "isbn": "9787554623046",
        "publisher": "古吴轩出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10130": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4621876,
        "gid": 4621876,
        "goodsType": 1,
        "price": 108.0000,
        "discount": 1,
        "discountPrice": 108.0000,
        "currency": 1,
        "createTime": "2024-08-27 15:04:44",
        "cnIbraryType": "J1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/UiFeQDslf.jpg",
        "topic": "巴黎有座艺术桥",
        "title": "巴黎有座艺术桥",
        "author": "[法]卡特琳·莫里斯",
        "isbn": "9787807684503",
        "publisher": "生活书店出版有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4474154,
        "gid": 4474154,
        "goodsType": 1,
        "price": 188.0000,
        "discount": 1,
        "discountPrice": 188.0000,
        "currency": 1,
        "createTime": "2024-08-28 13:53:05",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7maY4k4QM.jpg",
        "topic": "一百僧佛图",
        "title": "一百僧佛图",
        "author": "卢延光",
        "isbn": "9787554712009",
        "publisher": "天津杨柳青画社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4307216,
        "gid": 4307216,
        "goodsType": 1,
        "price": 169.0000,
        "discount": 1,
        "discountPrice": 169.0000,
        "currency": 1,
        "createTime": "2024-08-28 14:14:49",
        "cnIbraryType": "J1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/F9VA9hXWe.jpg",
        "topic": "文艺复兴时期的意大利艺术",
        "title": "文艺复兴时期的意大利艺术",
        "author": "（意）斯特凡诺·祖菲",
        "isbn": "9787542679543",
        "publisher": "上海三联书店",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4351144,
        "gid": 4351144,
        "goodsType": 1,
        "price": 169.0000,
        "discount": 1,
        "discountPrice": 169.0000,
        "currency": 1,
        "createTime": "2024-08-28 14:14:49",
        "cnIbraryType": "J1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/BSs8OmbWE.jpg",
        "topic": "十七世纪的意大利艺术",
        "title": "十七世纪的意大利艺术",
        "author": "（意）斯特凡诺·祖菲",
        "isbn": "9787542680266",
        "publisher": "上海三联书店",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4591761,
        "gid": 4591761,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:19:26",
        "cnIbraryType": "J06",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ISVJByiBw.jpg",
        "topic": "中国色：手艺里的中国色彩美学",
        "title": "中国色：手艺里的中国色彩美学",
        "author": "张雨秋",
        "isbn": "9787513943789",
        "publisher": "民主与建设出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4434033,
        "gid": 4434033,
        "goodsType": 1,
        "price": 89.8000,
        "discount": 1,
        "discountPrice": 89.8000,
        "currency": 1,
        "createTime": "2024-08-29 16:59:11",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/JugeVFjEy.jpg",
        "topic": "艺术终结者",
        "title": "艺术终结者",
        "author": "",
        "isbn": "9787500174110",
        "publisher": "中译出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4417606,
        "gid": 4417606,
        "goodsType": 1,
        "price": 60.0000,
        "discount": 1,
        "discountPrice": 60.0000,
        "currency": 1,
        "createTime": "2024-08-30 11:01:42",
        "cnIbraryType": "J",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/lsxkGuj4b.jpg",
        "topic": "艺术的品格",
        "title": "艺术的品格",
        "author": "乔舒亚·雷诺兹著",
        "isbn": "9787568096331",
        "publisher": "华中科技大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4460532,
        "gid": 4460532,
        "goodsType": 1,
        "price": 118.0000,
        "discount": 1,
        "discountPrice": 118.0000,
        "currency": 1,
        "createTime": "2024-08-30 13:18:56",
        "cnIbraryType": "J110.9",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/dMSFzTf1q.jpg",
        "topic": "艺术与争斗 : 艺术史上的大师之战",
        "title": "艺术与争斗 : 艺术史上的大师之战",
        "author": "[英]克莱顿·舒斯特尔（Clayton Schuster）著",
        "isbn": "9787568098632",
        "publisher": "华中科技大学出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10131": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4592896,
        "gid": 4592896,
        "goodsType": 1,
        "price": 109.0000,
        "discount": 1,
        "discountPrice": 109.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:14:35",
        "cnIbraryType": "TP18",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/QFbRNZ8Yk.jpg",
        "topic": "人工智能安全",
        "title": "人工智能安全",
        "author": "陈左宁",
        "isbn": "9787121471414",
        "publisher": "电子工业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4607525,
        "gid": 4607525,
        "goodsType": 1,
        "price": 56.0000,
        "discount": 1,
        "discountPrice": 56.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:51",
        "cnIbraryType": "R247.1",
        "imageUrl": "http://img3.winxuancdn.com/2041/1203332041_0_1_800x800.jpg?1716772043235",
        "topic": "吃对才会瘦",
        "title": "吃对才会瘦",
        "author": "邱超平著",
        "isbn": "9787523512296",
        "publisher": "科学技术文献出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4523956,
        "gid": 4523956,
        "goodsType": 1,
        "price": 58.0000,
        "discount": 1,
        "discountPrice": 58.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:54",
        "cnIbraryType": "G78",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/0JvBnRigq.jpg",
        "topic": "父母：挑战",
        "title": "父母：挑战",
        "author": "(美) 鲁道夫·德雷克斯著 ; 陈璇译",
        "isbn": "9787213110948",
        "publisher": "浙江人民出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4612465,
        "gid": 4612465,
        "goodsType": 1,
        "price": 59.8000,
        "discount": 1,
        "discountPrice": 59.8000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:54",
        "cnIbraryType": "R161",
        "imageUrl": "http://img2.winxuancdn.com/5901/1203335901_0_1_800x800.jpg?1720666094369",
        "topic": "减脂控糖",
        "title": "减脂控糖",
        "author": "唐黎之著",
        "isbn": "9787574219991",
        "publisher": "天津科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4515735,
        "gid": 4515735,
        "goodsType": 1,
        "price": 68.0000,
        "discount": 1,
        "discountPrice": 68.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "TS976.15",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ke1YerqZC.jpg",
        "topic": "家庭财报“十字表”：和你一起穿越经济寒冬",
        "title": "家庭财报“十字表”：和你一起穿越经济寒冬",
        "author": "贾昌勇",
        "isbn": "9787520737364",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4515437,
        "gid": 4515437,
        "goodsType": 1,
        "price": 76.0000,
        "discount": 1,
        "discountPrice": 76.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:20:44",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/VHCOaTukY.jpg",
        "topic": "敢闯才会赢（塑封）",
        "title": "敢闯才会赢（塑封）",
        "author": "徐方毅",
        "isbn": "9787523403389",
        "publisher": "团结出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4555777,
        "gid": 4555777,
        "goodsType": 1,
        "price": 45.0000,
        "discount": 1,
        "discountPrice": 45.0000,
        "currency": 1,
        "createTime": "2024-08-29 09:47:15",
        "cnIbraryType": "文化教育及其他",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/RMoWhKRjo.jpg",
        "topic": "这样立规矩，孩子更自律",
        "title": "这样立规矩，孩子更自律",
        "author": "陈晓群",
        "isbn": "9787571921903",
        "publisher": "黑龙江科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4592058,
        "gid": 4592058,
        "goodsType": 1,
        "price": 42.8000,
        "discount": 1,
        "discountPrice": 42.8000,
        "currency": 1,
        "createTime": "2024-08-29 13:49:30",
        "cnIbraryType": "G78",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/aC3D07ucA.jpg",
        "topic": "高敏感孩子的内心世界",
        "title": "高敏感孩子的内心世界",
        "author": "[法]克莉司德·布提可南",
        "isbn": "9787547064924",
        "publisher": "万卷出版有限责任公司",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10132": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4537443,
        "gid": 4537443,
        "goodsType": 1,
        "price": 46.0000,
        "discount": 1,
        "discountPrice": 46.0000,
        "currency": 1,
        "createTime": "2024-08-26 10:36:58",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/3PibFNI1a.jpg",
        "topic": "读读儿童故事（全二册）",
        "title": "读读儿童故事（全二册）",
        "author": "孙建江",
        "isbn": "9787570231706",
        "publisher": "长江文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4523073,
        "gid": 4523073,
        "goodsType": 1,
        "price": 198.0000,
        "discount": 1,
        "discountPrice": 198.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "R780.1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/06JbFdMRT.jpg",
        "topic": "儿童口腔科普绘本（全4本）（RMLH）",
        "title": "儿童口腔科普绘本（全4本）（RMLH）",
        "author": "王晴 沃嘉伟",
        "isbn": "9787520737647",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4632821,
        "gid": 4632821,
        "goodsType": 1,
        "price": 39.8000,
        "discount": 1,
        "discountPrice": 39.8000,
        "currency": 1,
        "createTime": "2024-08-29 11:10:03",
        "cnIbraryType": "I287.8",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/dQLzMV4aM.jpg",
        "topic": "收服小白龙（精装绘本）",
        "title": "收服小白龙（精装绘本）",
        "author": "孙硕夫",
        "isbn": "9787558584398",
        "publisher": "北方妇女儿童出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4632823,
        "gid": 4632823,
        "goodsType": 1,
        "price": 39.8000,
        "discount": 1,
        "discountPrice": 39.8000,
        "currency": 1,
        "createTime": "2024-08-29 11:10:03",
        "cnIbraryType": "I287.8",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/X5DKQanMF.jpg",
        "topic": "巧斗黄风怪（精装绘本）",
        "title": "巧斗黄风怪（精装绘本）",
        "author": "孙硕夫",
        "isbn": "9787558584367",
        "publisher": "北方妇女儿童出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4555686,
        "gid": 4555686,
        "goodsType": 1,
        "price": 39.8000,
        "discount": 1,
        "discountPrice": 39.8000,
        "currency": 1,
        "createTime": "2024-08-29 11:10:04",
        "cnIbraryType": "I287.8",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ywOxhEi97.jpg",
        "topic": "趣味伴读--火山爸爸，乌云妈妈",
        "title": "趣味伴读--火山爸爸，乌云妈妈",
        "author": "刘宝恒",
        "isbn": "9787575100908",
        "publisher": "浙江人民美术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4568254,
        "gid": 4568254,
        "goodsType": 1,
        "price": 69.0000,
        "discount": 1,
        "discountPrice": 69.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:12:12",
        "cnIbraryType": "P159",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/efdRsdy33.jpg",
        "topic": "给孩子的宇宙简史",
        "title": "给孩子的宇宙简史",
        "author": "[法]大卫·马尔尚、[法]纪尧姆·普雷沃 著\n[西]丹尼尔·迪奥斯达多绘\n丁月圆 译",
        "isbn": "9787519478001",
        "publisher": "光明日报出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4568252,
        "gid": 4568252,
        "goodsType": 1,
        "price": 69.0000,
        "discount": 1,
        "discountPrice": 69.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:12:12",
        "cnIbraryType": "P183",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/k3K7LLYY3.jpg",
        "topic": "给孩子的地球简史",
        "title": "给孩子的地球简史",
        "author": "[英]马丁·英斯 著 刘凯译",
        "isbn": "9787519477981",
        "publisher": "光明日报出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4606366,
        "gid": 4606366,
        "goodsType": 1,
        "price": 239.0000,
        "discount": 1,
        "discountPrice": 239.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:12:12",
        "cnIbraryType": "K204.1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/aH8gsO6jT.jpg",
        "topic": "少年读史 小二十四史",
        "title": "少年读史 小二十四史",
        "author": "谢冕 解玺璋 主编\n文小通 编著",
        "isbn": "9787514243352",
        "publisher": "文化发展出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10133": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [
        {
          "goodsId": 4562250,
          "gid": 4562250,
          "goodsType": 1,
          "price": 59.00,
          "discount": 1,
          "discountPrice": 59.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "F279.92",
          "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7nzLLZkVZ.jpg",
          "topic": " 激励与绩效",
          "title": "激励与绩效",
          "author": " 郭送斌, 蒋俊鹏著",
          "isbn": "9787515838496",
          "publisher": "中华工商联合出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
          "goodsId": 4670500,
          "gid": 4670500,
          "goodsType": 1,
          "price": 78.00,
          "discount": 1,
          "discountPrice": 78.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "F272.92",
          "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/2ZWYPaJdQ.jpg",
          "topic": "HR从零到精益",
          "title": "HR从零到精益",
          "author": " 郭送斌, 蒋俊鹏著",
          "isbn": "9787515840451",
          "publisher": "中华工商联合出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
          "goodsId": 4615870,
          "gid": 4615870,
          "goodsType": 1,
          "price": 78.00,
          "discount": 1,
          "discountPrice": 78.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "F124",
          "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Tq3UqTmys.jpg",
          "topic": "下一个风口",
          "title": "下一个风口",
          "author": "周超著",
          "isbn": "9787515839233",
          "publisher": "中华工商联合出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
          "goodsId": 4670501,
          "gid": 4670501,
          "goodsType": 1,
          "price": 58.00,
          "discount": 1,
          "discountPrice": 58.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "F71",
          "imageUrl": "https://test.ytzhihui.com/pic/newimg/xuanwo/c8c1ec79dfce4851b2230705198697b2.jpg",
          "topic": "好的商业模式需要创新设计",
          "title": "好的商业模式需要创新设计 ",
          "author": "郑小四著",
          "isbn": "9787515840277",
          "publisher": "中华工商联合出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
          "goodsId": 4581527,
          "gid": 4581527,
          "goodsType": 1,
          "price": 68.00,
          "discount": 1,
          "discountPrice": 68.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "F713",
          "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/SXm7NlFPq.jpg",
          "topic": "跟胖东来学经营",
          "title": "跟胖东来学经营",
          "author": "付守永著",
          "isbn": "9787515838991",
          "publisher": "中华工商联合出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
        "goodsId": 4607585,
        "gid": 4607585,
        "goodsType": 1,
        "price": 59.8000,
        "discount": 1,
        "discountPrice": 59.8000,
        "currency": 1,
        "createTime": "2024-08-26 11:06:19",
        "cnIbraryType": "B821",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/YiIKteB7N.jpg",
        "topic": "无：生命的最佳状态",
        "title": "无：生命的最佳状态",
        "author": "[日]铃木祐",
        "isbn": "9787209149846",
        "publisher": "山东人民出版社",
        "selectNum": 0,
        "allNum": 0
      }
      , {
        "goodsId": 4634236,
        "gid": 4634236,
        "goodsType": 1,
        "price": 55.0000,
        "discount": 1,
        "discountPrice": 55.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:51",
        "cnIbraryType": "I247.5",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/yngkR3ESq.jpg",
        "topic": "偷风不偷月",
        "title": "偷风不偷月",
        "author": "北南",
        "isbn": "9787221180407",
        "publisher": "贵州人民出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4596695,
        "gid": 4596695,
        "goodsType": 1,
        "price": 49.8000,
        "discount": 1,
        "discountPrice": 49.8000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:53",
        "cnIbraryType": "I247.5",
        "imageUrl": "http://img3.winxuancdn.com/4085/1203324085_0_1_800x800.jpg?1719193319837",
        "topic": "逐夏",
        "title": "逐夏",
        "author": "木瓜黄著",
        "isbn": "9787522526973",
        "publisher": "九州出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10134": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4592606,
        "gid": 4592606,
        "goodsType": 1,
        "price": 49.8000,
        "discount": 1,
        "discountPrice": 49.8000,
        "currency": 1,
        "createTime": "2024-08-26 10:36:58",
        "cnIbraryType": "",
        "imageUrl": "http://img2.winxuancdn.com/1246/1203321246_0_1_800x800.jpg?1714355700238",
        "topic": "零公里（修订本）（红色封面）",
        "title": "零公里（修订本）（红色封面）",
        "author": "王族",
        "isbn": "9787570226665",
        "publisher": "长江文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4535244,
        "gid": 4535244,
        "goodsType": 1,
        "price": 72.0000,
        "discount": 1,
        "discountPrice": 72.0000,
        "currency": 1,
        "createTime": "2024-08-26 11:06:18",
        "cnIbraryType": "I",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ujnwl83FH.jpg",
        "topic": "沏：茶的奇遇",
        "title": "沏：茶的奇遇",
        "author": "亨丽埃塔?洛弗尔",
        "isbn": "9787551105279",
        "publisher": "花山文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4652345,
        "gid": 4652345,
        "goodsType": 1,
        "price": 288.0000,
        "discount": 1,
        "discountPrice": 288.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:53",
        "cnIbraryType": "I247.5",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/VvhIBRWAo.jpg",
        "topic": "知否知否应是绿肥红瘦（全6册）",
        "title": "知否知否应是绿肥红瘦（全6册）",
        "author": "关心则乱",
        "isbn": "9787559482808",
        "publisher": "江苏凤凰文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4527413,
        "gid": 4527413,
        "goodsType": 1,
        "price": 49.0000,
        "discount": 1,
        "discountPrice": 49.0000,
        "currency": 1,
        "createTime": "2024-08-28 10:04:21",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/mE2qEFXo0.jpg",
        "topic": "西南风物笔记",
        "title": "西南风物笔记",
        "author": "蒋蓝",
        "isbn": "9787539676111",
        "publisher": "安徽文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4521427,
        "gid": 4521427,
        "goodsType": 1,
        "price": 49.0000,
        "discount": 1,
        "discountPrice": 49.0000,
        "currency": 1,
        "createTime": "2024-08-28 14:14:49",
        "cnIbraryType": "I",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/15T9pqtzW.jpg",
        "topic": "隐秘的终点",
        "title": "隐秘的终点",
        "author": "（美）娜塔莎·特雷休伊",
        "isbn": "9787542681201",
        "publisher": "上海三联书店",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4571975,
        "gid": 4571975,
        "goodsType": 1,
        "price": 69.8000,
        "discount": 1,
        "discountPrice": 69.8000,
        "currency": 1,
        "createTime": "2024-08-29 08:34:25",
        "cnIbraryType": "I25",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/XlmDaV8KV.jpg",
        "topic": "坐看水云：沈从文别传",
        "title": "坐看水云：沈从文别传",
        "author": "刘宜庆 著",
        "isbn": "9787554581896",
        "publisher": "河北教育出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4615791,
        "gid": 4615791,
        "goodsType": 1,
        "price": 45.0000,
        "discount": 1,
        "discountPrice": 45.0000,
        "currency": 1,
        "createTime": "2024-08-29 13:49:30",
        "cnIbraryType": "I",
        "imageUrl": "http://img3.winxuancdn.com/0235/1203330235_0_1_800x800.jpg?1716859996117",
        "topic": "心间事，舌尖解",
        "title": "心间事，舌尖解",
        "author": "[新]蔡澜",
        "isbn": "9787530688373",
        "publisher": "百花文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4559210,
        "gid": 4559210,
        "goodsType": 1,
        "price": 118.0000,
        "discount": 1,
        "discountPrice": 118.0000,
        "currency": 1,
        "createTime": "2024-08-29 14:14:15",
        "cnIbraryType": "I25",
        "imageUrl": "http://img3.winxuancdn.com/2486/1203282486_0_1_800x800.jpg?1709172451154",
        "topic": "热血：东北抗联",
        "title": "热血：东北抗联",
        "author": "李发锁",
        "isbn": "9787538772685",
        "publisher": "时代文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10135": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4646201,
        "gid": 4646201,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-27 16:34:51",
        "cnIbraryType": "D267.6",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/quaJpfDQp.jpg",
        "topic": "高校党建与思政教育融合发展研究",
        "title": "高校党建与思政教育融合发展研究",
        "author": "杨瑞",
        "isbn": "9787512058958",
        "publisher": "线装书局",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4646198,
        "gid": 4646198,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-27 16:34:51",
        "cnIbraryType": "D64",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/oFqsvAvMa.jpg",
        "topic": "新时期思想政治教育机制的多维探索",
        "title": "新时期思想政治教育机制的多维探索",
        "author": "胡鹤泷",
        "isbn": "9787512059443",
        "publisher": "线装书局",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4551038,
        "gid": 4551038,
        "goodsType": 1,
        "price": 59.0000,
        "discount": 1,
        "discountPrice": 59.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "D267",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/xDk5yuWoB.jpg",
        "topic": "新时代基层党务工作实务",
        "title": "新时代基层党务工作实务",
        "author": "张荣臣  主编",
        "isbn": "9787520737456",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4644769,
        "gid": 4644769,
        "goodsType": 1,
        "price": 56.0000,
        "discount": 1,
        "discountPrice": 56.0000,
        "currency": 1,
        "createTime": "2024-08-28 15:39:44",
        "cnIbraryType": "D26",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/UEybogukk.jpg",
        "topic": "大党——强国时代的强党逻辑",
        "title": "大党——强国时代的强党逻辑",
        "author": "张艳斌",
        "isbn": "9787215133631",
        "publisher": "河南人民出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4536028,
        "gid": 4536028,
        "goodsType": 1,
        "price": 78.0000,
        "discount": 1,
        "discountPrice": 78.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:36:29",
        "cnIbraryType": "D267.6",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/QepZatpt6.jpg",
        "topic": "新时代高校党建工作发展之路",
        "title": "新时代高校党建工作发展之路",
        "author": "人民日报",
        "isbn": "9787511575487",
        "publisher": "人民日报出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4578066,
        "gid": 4578066,
        "goodsType": 1,
        "price": 68.0000,
        "discount": 1,
        "discountPrice": 68.0000,
        "currency": 1,
        "createTime": "2024-08-28 17:17:36",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/nk3dkMdfD.jpg",
        "topic": "大党独有难题的破解之道",
        "title": "大党独有难题的破解之道",
        "author": "陈远章  著",
        "isbn": "9787505154018",
        "publisher": "红旗出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4598988,
        "gid": 4598988,
        "goodsType": 1,
        "price": 68.0000,
        "discount": 1,
        "discountPrice": 68.0000,
        "currency": 1,
        "createTime": "2024-08-28 17:17:36",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/gCjbewgFg.jpg",
        "topic": "人类文明新形态",
        "title": "人类文明新形态",
        "author": "王英梅   著",
        "isbn": "9787218175065",
        "publisher": "广东人民出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4612318,
        "gid": 4612318,
        "goodsType": 1,
        "price": 130.0000,
        "discount": 1,
        "discountPrice": 130.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:35:35",
        "cnIbraryType": "D621.5",
        "imageUrl": "http://img3.winxuancdn.com/8044/1203338044_0_0_800x800.jpg?1717747570470",
        "topic": "全球人权治理的中国智慧：张彭春在联合国人权委员会及联大第三委员会等的发言",
        "title": "全球人权治理的中国智慧：张彭春在联合国人权委员会及联大第三委员会等的发言",
        "author": "孙平华",
        "isbn": "9787556308859",
        "publisher": "天津社会科学院出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10136": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4543033,
        "gid": 4543033,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:14:35",
        "cnIbraryType": "TP311.1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/1gOWJPt2r.jpg",
        "topic": "数据库应用实战",
        "title": "数据库应用实战",
        "author": "张粤磊 刘未昕等编著",
        "isbn": "9787121472299",
        "publisher": "电子工业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4519068,
        "gid": 4519068,
        "goodsType": 1,
        "price": 68.0000,
        "discount": 1,
        "discountPrice": 68.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:18:54",
        "cnIbraryType": "TP18",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/QHrNmL60k.jpg",
        "topic": "ChatGPT 时代：正在到来的人工智能新浪潮",
        "title": "ChatGPT 时代：正在到来的人工智能新浪潮",
        "author": "熙代著",
        "isbn": "9787505757295",
        "publisher": "中国友谊出版公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4640122,
        "gid": 4640122,
        "goodsType": 1,
        "price": 49.0000,
        "discount": 1,
        "discountPrice": 49.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:07:48",
        "cnIbraryType": "TP393.0",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/fkOhfXLkv.jpg",
        "topic": "大数据技术在网络安全中的应用与研究",
        "title": "大数据技术在网络安全中的应用与研究",
        "author": "胡明星",
        "isbn": "9787577006024",
        "publisher": "电子科技大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4588869,
        "gid": 4588869,
        "goodsType": 1,
        "price": 52.0000,
        "discount": 1,
        "discountPrice": 52.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:20:44",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/4wyCqiPed.jpg",
        "topic": "无人机载线阵列高光谱影像数据拼接技术及应用(塑封）",
        "title": "无人机载线阵列高光谱影像数据拼接技术及应用(塑封）",
        "author": "易俐娜张桂峰许志华",
        "isbn": "9787567433984",
        "publisher": "东北林业大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4560260,
        "gid": 4560260,
        "goodsType": 1,
        "price": 82.0000,
        "discount": 1,
        "discountPrice": 82.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:23:32",
        "cnIbraryType": "TP183",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/WdwKRuKjy.jpg",
        "topic": "时标上人工神经网络的加权伪概周期解与加权伪概自守解",
        "title": "时标上人工神经网络的加权伪概周期解与加权伪概自守解",
        "author": "赵莉莉著",
        "isbn": "9787522125862",
        "publisher": "中国原子能出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4597887,
        "gid": 4597887,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:56:04",
        "cnIbraryType": "TP311.5",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/zZuv8GHHC.jpg",
        "topic": "中国软件工程师:工作、生活与观念",
        "title": "中国软件工程师:工作、生活与观念",
        "author": "王天夫，闫泽华，孙百承[等]著",
        "isbn": "9787522830803",
        "publisher": "社会科学文献出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4520901,
        "gid": 4520901,
        "goodsType": 1,
        "price": 59.8000,
        "discount": 1,
        "discountPrice": 59.8000,
        "currency": 1,
        "createTime": "2024-08-29 10:12:19",
        "cnIbraryType": "TP18",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/HV7uNGdV8.jpg",
        "topic": "ChatGPT无限可能：人工智能引领财富升级之路",
        "title": "ChatGPT无限可能：人工智能引领财富升级之路",
        "author": "罗凯；郑立鹏著",
        "isbn": "9787520826334",
        "publisher": "中国商业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4546019,
        "gid": 4546019,
        "goodsType": 1,
        "price": 59.0000,
        "discount": 1,
        "discountPrice": 59.0000,
        "currency": 1,
        "createTime": "2024-08-30 14:50:24",
        "cnIbraryType": "TP274",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/j3nNVkX46.jpg",
        "topic": "大数据",
        "title": "大数据",
        "author": "（美）道恩·E.霍尔姆斯（Dawn E. Holmes）著",
        "isbn": "9787544799782",
        "publisher": "译林出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10137": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4620429,
        "gid": 4620429,
        "goodsType": 1,
        "price": 95.0000,
        "discount": 1,
        "discountPrice": 95.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:14:34",
        "cnIbraryType": "F124.1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/KiIIOvhLU.jpg",
        "topic": "流通促进经济循环的机制及数字化创新研究",
        "title": "流通促进经济循环的机制及数字化创新研究",
        "author": "庄尚文等",
        "isbn": "9787565452239",
        "publisher": "东北财经大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4646185,
        "gid": 4646185,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-27 16:34:51",
        "cnIbraryType": "F252.1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/G6eQUYZB1.jpg",
        "topic": "现代物流管理基础与信息系统研究",
        "title": "现代物流管理基础与信息系统研究",
        "author": "杨贺",
        "isbn": "9787516039465",
        "publisher": "中国建材工业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4646172,
        "gid": 4646172,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-27 16:34:51",
        "cnIbraryType": "F272",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/2KVxU48Aa.jpg",
        "topic": "现代企业管理信息化转型发展新视野",
        "title": "现代企业管理信息化转型发展新视野",
        "author": "庄树伟",
        "isbn": "9787516040683",
        "publisher": "中国建材工业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4646195,
        "gid": 4646195,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-27 16:34:51",
        "cnIbraryType": "F275",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/oCYdnvb2X.jpg",
        "topic": "信息化时代财务管理发展探析",
        "title": "信息化时代财务管理发展探析",
        "author": "潘富玲",
        "isbn": "9787512059771",
        "publisher": "线装书局",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4507965,
        "gid": 4507965,
        "goodsType": 1,
        "price": 54.0000,
        "discount": 1,
        "discountPrice": 54.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "C93-09",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/1kby1CDx6.jpg",
        "topic": "德鲁克管理哲学（DSHF）",
        "title": "德鲁克管理哲学（DSHF）",
        "author": "（日）桑原晃弥",
        "isbn": "9787520734691",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4635292,
        "gid": 4635292,
        "goodsType": 1,
        "price": 69.8000,
        "discount": 1,
        "discountPrice": 69.8000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "F120.2",
        "imageUrl": "http://img0.winxuancdn.com/4741/1203364741_0_1_800x800.jpg?1720427882013",
        "topic": "思维导图图解新质生产力（RMLH）",
        "title": "思维导图图解新质生产力（RMLH）",
        "author": "人民日报人民论坛杂志社 主编",
        "isbn": "9787520739771",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4575328,
        "gid": 4575328,
        "goodsType": 1,
        "price": 72.0000,
        "discount": 1,
        "discountPrice": 72.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:07:48",
        "cnIbraryType": "F124.5",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/YPaFHFHWb.jpg",
        "topic": "中国低碳循环经济发展模式研究",
        "title": "中国低碳循环经济发展模式研究",
        "author": "吴丽华",
        "isbn": "9787573136084",
        "publisher": "吉林出版集团股份有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4575310,
        "gid": 4575310,
        "goodsType": 1,
        "price": 68.0000,
        "discount": 1,
        "discountPrice": 68.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:07:48",
        "cnIbraryType": "F7",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/73A4Eq7c3.jpg",
        "topic": "商务英语跨文化翻译技巧与实践研究",
        "title": "商务英语跨文化翻译技巧与实践研究",
        "author": "刘瑞",
        "isbn": "9787576826715",
        "publisher": "吉林大学出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10138": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [
        {
          "goodsId": 4654751,
          "gid": 4654751,
          "goodsType": 1,
          "price": 3200.00,
          "discount": 1,
          "discountPrice": 3200.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "H121",
          "imageUrl": "https://test.ytzhihui.com/pic/newimg/xuanwo/200e8fa9bc4d4d9591ebf5b60053018a.png",
          "topic": "中国文物志·人物传",
          "title": "中国文物志·人物传",
          "author": "中国文物志编纂委员会编",
          "isbn": "9787501080458",
          "publisher": "文物出版社",
          "selectNum": 0,
          "allNum": 0
        },
        
        {
          "goodsId": 4367781,
          "gid": 4367781,
          "goodsType": 1,
          "price": 3200.00,
          "discount": 1,
          "discountPrice": 3200.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "H121",
          "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/W9kiO1f2L.jpg",
          "topic": "國別文字編",
          "title": "國別文字編",
          "author": " 李致忠主编",
          "isbn": "9787501079872",
          "publisher": "文物出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
          "goodsId": 4625057,
          "gid": 4625057,
          "goodsType": 1,
          "price": 980.00,
          "discount": 1,
          "discountPrice": 980.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "H121",
          "imageUrl": "https://test.ytzhihui.com/pic/newimg/xuanwo/200e8fa9bc4d4d9591ebf5b60053018a.png",
          "topic": "中国文物志·文献辑存（全三册）",
          "title": "中国文物志·文献辑存（全三册）",
          "author": "中国文物志编纂委员会编",
          "isbn": "9787501068371",
          "publisher": "文物出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
          "goodsId": 4434622,
          "gid": 4434622,
          "goodsType": 1,
          "price": 2250.00,
          "discount": 1,
          "discountPrice": 2250.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "Z812.1",
          "imageUrl": "https://test.ytzhihui.com/pic/newimg/xuanwo/85ac0a9e3b5e4a529a3903a1c61d2568.png",
          "topic": " 中国历代图书总目",
          "title": "中国历代图书总目",
          "author": " 李致忠主编",
          "isbn": "9787515838496",
          "publisher": "文物出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
          "goodsId": 4639977,
          "gid": 4639977,
          "goodsType": 1,
          "price": 3200.00,
          "discount": 1,
          "discountPrice": 3200.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "H121",
          "imageUrl": "https://test.ytzhihui.com/pic/newimg/xuanwo/200e8fa9bc4d4d9591ebf5b60053018a.png",
          "topic": "中国文物志：不可移动文物编（全四册）",
          "title": "中国文物志：不可移动文物编（全四册）",
          "author": "中国文物志编纂委员会编",
          "isbn": "9787501066599",
          "publisher": "文物出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
          "goodsId": 4682432,
          "gid": 4682432,
          "goodsType": 1,
          "price": 980.00,
          "discount": 1,
          "discountPrice": 980.00,
          "currency": 1,
          "createTime": "2024-08-26 11:06:19",
          "cnIbraryType": "H121",
          "imageUrl": "https://test.ytzhihui.com/pic/newimg/xuanwo/3152f9b1fef5409391bb0935fcc3ea19.png",
          "topic": "台北故宫博物院典藏大系-绘画卷",
          "title": "台北故宫博物院典藏大系-绘画卷",
          "author": "中国文物志编纂委员会编",
          "isbn": "9787501068371",
          "publisher": "文物出版社",
          "selectNum": 0,
          "allNum": 0
        },
        {
        "goodsId": 3533802,
        "gid": 3533802,
        "goodsType": 1,
        "price": 13000.0000,
        "discount": 1,
        "discountPrice": 13000.0000,
        "currency": 1,
        "createTime": "2024-08-28 10:30:34",
        "cnIbraryType": "Z121.7",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/dJyfkGx45.png",
        "topic": "大仓文库粹编·特殊印本",
        "title": "大仓文库粹编·特殊印本",
        "author": "北京大学图书馆 著",
        "isbn": "9787301312292",
        "publisher": "北京大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 3533803,
        "gid": 3533803,
        "goodsType": 1,
        "price": 17000.0000,
        "discount": 1,
        "discountPrice": 17000.0000,
        "currency": 1,
        "createTime": "2024-08-28 10:30:34",
        "cnIbraryType": "Z121.7",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ZYGm0Gc5s.jpg",
        "topic": "大仓文库粹编·和刻本·朝鲜刻本",
        "title": "大仓文库粹编·和刻本·朝鲜刻本",
        "author": "北京大学图书馆 著",
        "isbn": "9787301312308",
        "publisher": "北京大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, 
      // {
      //   "goodsId": 3533805,
      //   "gid": 3533805,
      //   "goodsType": 1,
      //   "price": 19000.0000,
      //   "discount": 1,
      //   "discountPrice": 19000.0000,
      //   "currency": 1,
      //   "createTime": "2024-08-28 10:30:34",
      //   "cnIbraryType": "Z121.7",
      //   "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/atX2Le7ON.jpg",
      //   "topic": "大仓文库粹编·四库进呈本",
      //   "title": "大仓文库粹编·四库进呈本",
      //   "author": "北京大学图书馆 著",
      //   "isbn": "9787301312285",
      //   "publisher": "北京大学出版社",
      //   "selectNum": 0,
      //   "allNum": 0
      // }, {
      //   "goodsId": 3533806,
      //   "gid": 3533806,
      //   "goodsType": 1,
      //   "price": 33000.0000,
      //   "discount": 1,
      //   "discountPrice": 33000.0000,
      //   "currency": 1,
      //   "createTime": "2024-08-28 10:30:34",
      //   "cnIbraryType": "Z121.7",
      //   "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/SQKRisQOe.jpg",
      //   "topic": "大仓文库粹编·活字本",
      //   "title": "大仓文库粹编·活字本",
      //   "author": "北京大学图书馆 著",
      //   "isbn": "9787301312254",
      //   "publisher": "北京大学出版社",
      //   "selectNum": 0,
      //   "allNum": 0
      // }, {
      //   "goodsId": 3533807,
      //   "gid": 3533807,
      //   "goodsType": 1,
      //   "price": 70000.0000,
      //   "discount": 1,
      //   "discountPrice": 70000.0000,
      //   "currency": 1,
      //   "createTime": "2024-08-28 10:30:34",
      //   "cnIbraryType": "Z121.7",
      //   "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/EM76VS7gl.jpg",
      //   "topic": "大仓文库粹编·精善刻本",
      //   "title": "大仓文库粹编·精善刻本",
      //   "author": "北京大学图书馆 著",
      //   "isbn": "9787301312261",
      //   "publisher": "北京大学出版社",
      //   "selectNum": 0,
      //   "allNum": 0
      // }, {
      //   "goodsId": 3533804,
      //   "gid": 3533804,
      //   "goodsType": 1,
      //   "price": 118000.0000,
      //   "discount": 1,
      //   "discountPrice": 118000.0000,
      //   "currency": 1,
      //   "createTime": "2024-08-28 10:30:34",
      //   "cnIbraryType": "Z121.7",
      //   "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/tmTjjXyBR.jpg",
      //   "topic": "大仓文库粹编·名家钞校本",
      //   "title": "大仓文库粹编·名家钞校本",
      //   "author": "北京大学图书馆 著",
      //   "isbn": "9787301312278",
      //   "publisher": "北京大学出版社",
      //   "selectNum": 0,
      //   "allNum": 0
      // }, {
      //   "goodsId": 3078496,
      //   "gid": 3078496,
      //   "goodsType": 1,
      //   "price": 198.0000,
      //   "discount": 1,
      //   "discountPrice": 198.0000,
      //   "currency": 1,
      //   "createTime": "2024-08-28 15:39:43",
      //   "cnIbraryType": "F1",
      //   "imageUrl": "http://newcover.ytzhihui.com/newcover/2018/198/9787215115071/9787215115071.jpg",
      //   "topic": "俄国社会经济史（专题史丛书 第四辑）",
      //   "title": "俄国社会经济史（专题史丛书 第四辑）",
      //   "author": "小林良正",
      //   "isbn": "9787215115071",
      //   "publisher": "河南人民出版社",
      //   "selectNum": 0,
      //   "allNum": 0
      // }, {
      //   "goodsId": 3078509,
      //   "gid": 3078509,
      //   "goodsType": 1,
      //   "price": 302.0000,
      //   "discount": 1,
      //   "discountPrice": 302.0000,
      //   "currency": 1,
      //   "createTime": "2024-08-28 15:39:43",
      //   "cnIbraryType": "F821.9",
      //   "imageUrl": "http://newcover.ytzhihui.com/newcover/2018/302/9787215115217/9787215115217.jpg",
      //   "topic": "稳定货币运动史：全两册（专题史丛书 第四辑）",
      //   "title": "稳定货币运动史：全两册（专题史丛书 第四辑）",
      //   "author": "（美）欧文·费雪",
      //   "isbn": "9787215115217",
      //   "publisher": "河南人民出版社",
      //   "selectNum": 0,
      //   "allNum": 0
      // }
    ]
    }
  },
  "10146": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4542838,
        "gid": 4542838,
        "goodsType": 1,
        "price": 89.0000,
        "discount": 1,
        "discountPrice": 89.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:14:35",
        "cnIbraryType": "TP393.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/jKoPIa0wl.jpg",
        "topic": "物联网大数据处理技术与实践",
        "title": "物联网大数据处理技术与实践",
        "author": "王强 赵卓峰 韩艳波",
        "isbn": "9787121472060",
        "publisher": "电子工业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4632626,
        "gid": 4632626,
        "goodsType": 1,
        "price": 108.0000,
        "discount": 1,
        "discountPrice": 108.0000,
        "currency": 1,
        "createTime": "2024-08-27 11:20:55",
        "cnIbraryType": "TP391.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/0jXFY1QE2.jpg",
        "topic": "AIGC绘画精讲：Midjourney+Stable Diffusion+ChatGPT从入门到精通",
        "title": "AIGC绘画精讲：Midjourney+Stable Diffusion+ChatGPT从入门到精通",
        "author": "未蓝文化",
        "isbn": "9787515373041",
        "publisher": "中国青年出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4604090,
        "gid": 4604090,
        "goodsType": 1,
        "price": 69.9000,
        "discount": 1,
        "discountPrice": 69.9000,
        "currency": 1,
        "createTime": "2024-08-27 11:20:55",
        "cnIbraryType": "TP391.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/GdtTKI7K2.jpg",
        "topic": "3ds Max 2024中文全彩铂金版案例教程",
        "title": "3ds Max 2024中文全彩铂金版案例教程",
        "author": "高博，王婧，龙舟君",
        "isbn": "9787515372594",
        "publisher": "中国青年出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4599378,
        "gid": 4599378,
        "goodsType": 1,
        "price": 89.0000,
        "discount": 1,
        "discountPrice": 89.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:23:31",
        "cnIbraryType": "TP391.1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7erBgJkup.jpg",
        "topic": "Excel 数据分析及其在管理中的应用研究",
        "title": "Excel 数据分析及其在管理中的应用研究",
        "author": "韩育芳,李艳",
        "isbn": "9787577008325",
        "publisher": "电子科技大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4641968,
        "gid": 4641968,
        "goodsType": 1,
        "price": 48.0000,
        "discount": 1,
        "discountPrice": 48.0000,
        "currency": 1,
        "createTime": "2024-08-30 11:01:45",
        "cnIbraryType": "TP311.5",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/J782j7z9Q.jpg",
        "topic": "软件测试用例集约简算法研究",
        "title": "软件测试用例集约简算法研究",
        "author": "华丽著",
        "isbn": "9787577209630",
        "publisher": "华中科技大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4618850,
        "gid": 4618850,
        "goodsType": 1,
        "price": 69.0000,
        "discount": 1,
        "discountPrice": 69.0000,
        "currency": 1,
        "createTime": "2024-08-30 13:58:15",
        "cnIbraryType": "T",
        "imageUrl": "http://img0.winxuancdn.com/1588/1203341588_0_0_800x800.jpg?1717751785524",
        "topic": "计算机信息技术理论与大数据应用新探",
        "title": "计算机信息技术理论与大数据应用新探",
        "author": "王波, 李斌, 魏贵娟著",
        "isbn": "9787510347351",
        "publisher": "中国商务出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4652557,
        "gid": 4652557,
        "goodsType": 1,
        "price": 95.0000,
        "discount": 1,
        "discountPrice": 95.0000,
        "currency": 1,
        "createTime": "2024-08-30 14:00:00",
        "cnIbraryType": "TP393.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/J0Nf8quZs.jpg",
        "topic": "网络空间治理研究",
        "title": "网络空间治理研究",
        "author": "秦小琪",
        "isbn": "9787519478704",
        "publisher": "光明日报出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4628491,
        "gid": 4628491,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-09-02 11:05:32",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/lWULYjSE4.jpg",
        "topic": "网络化科学的认识论研究",
        "title": "网络化科学的认识论研究",
        "author": "",
        "isbn": "9787552042894",
        "publisher": "上海社会科学院出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10147": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4637367,
        "gid": 4637367,
        "goodsType": 1,
        "price": 29.0000,
        "discount": 1,
        "discountPrice": 29.0000,
        "currency": 1,
        "createTime": "2024-08-26 10:16:08",
        "cnIbraryType": "G449.7",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Pjc0oylUH.jpg",
        "topic": "学生评价伦理：案例与分析",
        "title": "学生评价伦理：案例与分析",
        "author": "朱丽",
        "isbn": "9787533498009",
        "publisher": "福建教育出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4649137,
        "gid": 4649137,
        "goodsType": 1,
        "price": 45.0000,
        "discount": 1,
        "discountPrice": 45.0000,
        "currency": 1,
        "createTime": "2024-08-26 10:16:08",
        "cnIbraryType": "G622.42",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/3UOz8Dkw8.jpg",
        "topic": "以大概念为本的大单元教学实践探索",
        "title": "以大概念为本的大单元教学实践探索",
        "author": "莆田市实验小学（余文森主编）",
        "isbn": "9787533499556",
        "publisher": "福建教育出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4631765,
        "gid": 4631765,
        "goodsType": 1,
        "price": 42.0000,
        "discount": 1,
        "discountPrice": 42.0000,
        "currency": 1,
        "createTime": "2024-08-26 10:16:08",
        "cnIbraryType": "G40-02",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/vsOr5cOAI.jpg",
        "topic": "论语教育哲学",
        "title": "论语教育哲学",
        "author": "叶水涛",
        "isbn": "9787533499518",
        "publisher": "福建教育出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4625133,
        "gid": 4625133,
        "goodsType": 1,
        "price": 79.0000,
        "discount": 1,
        "discountPrice": 79.0000,
        "currency": 1,
        "createTime": "2024-08-26 10:16:08",
        "cnIbraryType": "G649.20",
        "imageUrl": "http://img2.winxuancdn.com/1694/1203361694_0_1_800x800.jpg?1720501824209",
        "topic": "从外延式治理走向内涵式治理：经合组织高等教育政策发展研究（1948-2018）",
        "title": "从外延式治理走向内涵式治理：经合组织高等教育政策发展研究（1948-2018）",
        "author": "李安琪",
        "isbn": "9787533499365",
        "publisher": "福建教育出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4625130,
        "gid": 4625130,
        "goodsType": 1,
        "price": 59.0000,
        "discount": 1,
        "discountPrice": 59.0000,
        "currency": 1,
        "createTime": "2024-08-26 10:16:08",
        "cnIbraryType": "G612",
        "imageUrl": "http://img2.winxuancdn.com/1699/1203361699_0_0_800x800.jpg?1720489347991",
        "topic": "以儿童为中心的幼儿园课程故事30例 ——基于幼儿园课程质量提升的探索与实践",
        "title": "以儿童为中心的幼儿园课程故事30例 ——基于幼儿园课程质量提升的探索与实践",
        "author": "吴丽珍",
        "isbn": "9787533499488",
        "publisher": "福建教育出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4611160,
        "gid": 4611160,
        "goodsType": 1,
        "price": 58.0000,
        "discount": 1,
        "discountPrice": 58.0000,
        "currency": 1,
        "createTime": "2024-08-26 10:16:08",
        "cnIbraryType": "G633",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/pWoxnRpl5.jpg",
        "topic": "大概念统领的跨学科项目式教学设计 高中化学",
        "title": "大概念统领的跨学科项目式教学设计 高中化学",
        "author": "江合佩，李勇",
        "isbn": "9787533499105",
        "publisher": "福建教育出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4640568,
        "gid": 4640568,
        "goodsType": 1,
        "price": 118.0000,
        "discount": 1,
        "discountPrice": 118.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:08:46",
        "cnIbraryType": "G40-051",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/So456dhLV.jpg",
        "topic": "教育量化研究与SPSS分析技术应用",
        "title": "教育量化研究与SPSS分析技术应用",
        "author": "刘兰英 著",
        "isbn": "9787542881359",
        "publisher": "上海科技教育出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4586322,
        "gid": 4586322,
        "goodsType": 1,
        "price": 128.0000,
        "discount": 1,
        "discountPrice": 128.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:08:46",
        "cnIbraryType": "G633.7",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/MaPwPIw35.jpg",
        "topic": "技术与工程素养标准：技术与工程在STEM教育中的作用",
        "title": "技术与工程素养标准：技术与工程在STEM教育中的作用",
        "author": "[美]国际技术与工程教育协会(ITEEA)",
        "isbn": "9787542881175",
        "publisher": "上海科技教育出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10149": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4619143,
        "gid": 4619143,
        "goodsType": 1,
        "price": 69.8000,
        "discount": 1,
        "discountPrice": 69.8000,
        "currency": 1,
        "createTime": "2024-08-28 16:07:48",
        "cnIbraryType": "J419.1",
        "imageUrl": "http://img2.winxuancdn.com/1361/1203331361_0_0_800x800.jpg?1717117382269",
        "topic": "现代新闻摄影研究",
        "title": "现代新闻摄影研究",
        "author": "王凯",
        "isbn": "9787572914713",
        "publisher": "天津人民美术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4575313,
        "gid": 4575313,
        "goodsType": 1,
        "price": 58.0000,
        "discount": 1,
        "discountPrice": 58.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:07:48",
        "cnIbraryType": "J901",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ncjn7xt7H.jpg",
        "topic": "时空中的曼妙光影—艺术电影美学理论研究",
        "title": "时空中的曼妙光影—艺术电影美学理论研究",
        "author": "李阳",
        "isbn": "9787548953890",
        "publisher": "云南美术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4586177,
        "gid": 4586177,
        "goodsType": 1,
        "price": 86.0000,
        "discount": 1,
        "discountPrice": 86.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:23:32",
        "cnIbraryType": "J114",
        "imageUrl": "http://img2.winxuancdn.com/4732/1203314732_0_0_800x800.jpg?1713334521311",
        "topic": "美术教育的学科研究与教学实践",
        "title": "美术教育的学科研究与教学实践",
        "author": "邱国光",
        "isbn": "9787516671054",
        "publisher": "新华出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4560286,
        "gid": 4560286,
        "goodsType": 1,
        "price": 69.0000,
        "discount": 1,
        "discountPrice": 69.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:23:32",
        "cnIbraryType": "J624.1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/aBjysDac2.jpg",
        "topic": "中西方钢琴音乐艺术风格探究",
        "title": "中西方钢琴音乐艺术风格探究",
        "author": "李小琳著",
        "isbn": "9787504390875",
        "publisher": "中国广播影视出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4507681,
        "gid": 4507681,
        "goodsType": 1,
        "price": 80.0000,
        "discount": 1,
        "discountPrice": 80.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:52:02",
        "cnIbraryType": "J60-05",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Zy3Wvpsn8.jpg",
        "topic": "高校学术研究论著丛刊（艺术体育）— 新时代美育背景下学校音乐教育研究",
        "title": "高校学术研究论著丛刊（艺术体育）— 新时代美育背景下学校音乐教育研究",
        "author": "静心苑 周泱",
        "isbn": "9787506894593",
        "publisher": "中国书籍出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4507682,
        "gid": 4507682,
        "goodsType": 1,
        "price": 82.0000,
        "discount": 1,
        "discountPrice": 82.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:52:02",
        "cnIbraryType": "J607",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/j2xcWnMyT.jpg",
        "topic": "高校学术研究论著丛刊（艺术体育）— 困境与消解：红水河流域民族音乐发展研究",
        "title": "高校学术研究论著丛刊（艺术体育）— 困境与消解：红水河流域民族音乐发展研究",
        "author": "静心苑 杨婷",
        "isbn": "9787506894609",
        "publisher": "中国书籍出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4507686,
        "gid": 4507686,
        "goodsType": 1,
        "price": 82.0000,
        "discount": 1,
        "discountPrice": 82.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:52:02",
        "cnIbraryType": "J616.2",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/SF0GnLTKX.jpg",
        "topic": "高校学术研究论著丛刊（艺术体育）— 美声唱法及其在中国本土声乐艺术中的融合",
        "title": "高校学术研究论著丛刊（艺术体育）— 美声唱法及其在中国本土声乐艺术中的融合",
        "author": "静心苑 杨柳琴",
        "isbn": "9787506895583",
        "publisher": "中国书籍出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4507669,
        "gid": 4507669,
        "goodsType": 1,
        "price": 78.0000,
        "discount": 1,
        "discountPrice": 78.0000,
        "currency": 1,
        "createTime": "2024-08-29 15:52:03",
        "cnIbraryType": "J613.1",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7FiWy3Zjj.jpg",
        "topic": "高校学术研究成果丛书— 基于发展音乐听觉的视唱练耳研究",
        "title": "高校学术研究成果丛书— 基于发展音乐听觉的视唱练耳研究",
        "author": "守正文化 刘玮",
        "isbn": "9787506895972",
        "publisher": "中国书籍出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10150": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4516333,
        "gid": 4516333,
        "goodsType": 1,
        "price": 128.0000,
        "discount": 1,
        "discountPrice": 128.0000,
        "currency": 1,
        "createTime": "2024-08-28 13:26:03",
        "cnIbraryType": "TU-092",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Itsj2799l.jpg",
        "topic": "中国建筑史（营造书系）",
        "title": "中国建筑史（营造书系）",
        "author": "梁思成 著",
        "isbn": "9787573209306",
        "publisher": "上海古籍出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4575341,
        "gid": 4575341,
        "goodsType": 1,
        "price": 90.0000,
        "discount": 1,
        "discountPrice": 90.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:07:48",
        "cnIbraryType": "TU2",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/5c3LXQKDE.jpg",
        "topic": "基于地域性的城市文化建设再生与重构",
        "title": "基于地域性的城市文化建设再生与重构",
        "author": "鲁文婷 裴昊",
        "isbn": "9787573139245",
        "publisher": "吉林出版集团股份有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4560304,
        "gid": 4560304,
        "goodsType": 1,
        "price": 86.0000,
        "discount": 1,
        "discountPrice": 86.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:23:32",
        "cnIbraryType": "TU2",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/SI3QkXBGv.jpg",
        "topic": "建筑空间展示设计与视觉元素呈现研究",
        "title": "建筑空间展示设计与视觉元素呈现研究",
        "author": "马晓冬，著",
        "isbn": "9787573134790",
        "publisher": "吉林出版集团股份有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4575641,
        "gid": 4575641,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-29 06:48:27",
        "cnIbraryType": "TU",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Na7EZMfcX.jpg",
        "topic": "你的建筑生涯",
        "title": "你的建筑生涯",
        "author": "加里&#65381;昂格尔",
        "isbn": "9787559129758",
        "publisher": "辽宁科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4580462,
        "gid": 4580462,
        "goodsType": 1,
        "price": 58.0000,
        "discount": 1,
        "discountPrice": 58.0000,
        "currency": 1,
        "createTime": "2024-08-29 06:48:27",
        "cnIbraryType": "TU-091",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/vMeCZCcNi.jpg",
        "topic": "地文",
        "title": "地文",
        "author": "承孝相",
        "isbn": "9787559124982",
        "publisher": "辽宁科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4619340,
        "gid": 4619340,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-29 06:48:27",
        "cnIbraryType": "TU986.2",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/NqiIyLO2y.jpg",
        "topic": "打造美丽的小庭院：花园设计与装饰技巧",
        "title": "打造美丽的小庭院：花园设计与装饰技巧",
        "author": "（日）E&G学院",
        "isbn": "9787559133526",
        "publisher": "辽宁科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4641873,
        "gid": 4641873,
        "goodsType": 1,
        "price": 298.0000,
        "discount": 1,
        "discountPrice": 298.0000,
        "currency": 1,
        "createTime": "2024-08-29 06:48:27",
        "cnIbraryType": "TU206",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/BDqmajKXL.jpg",
        "topic": "不止设计",
        "title": "不止设计",
        "author": "郭晰纹",
        "isbn": "9787559129574",
        "publisher": "辽宁科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4626553,
        "gid": 4626553,
        "goodsType": 1,
        "price": 59.0000,
        "discount": 1,
        "discountPrice": 59.0000,
        "currency": 1,
        "createTime": "2024-08-30 10:23:33",
        "cnIbraryType": "TU",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/XA7iPqclP.jpg",
        "topic": "新型混凝土材料",
        "title": "新型混凝土材料",
        "author": "韩方晖 张增起",
        "isbn": "9787516040157",
        "publisher": "中国建材工业出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10151": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4545189,
        "gid": 4545189,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-28 10:30:43",
        "cnIbraryType": "TN929.53",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ob5nlrFDP.jpg",
        "topic": "Android开发工程师案例教程（Kotlin版）",
        "title": "Android开发工程师案例教程（Kotlin版）",
        "author": "倪红军编著",
        "isbn": "9787301346419",
        "publisher": "北京大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4552840,
        "gid": 4552840,
        "goodsType": 1,
        "price": 89.0000,
        "discount": 1,
        "discountPrice": 89.0000,
        "currency": 1,
        "createTime": "2024-08-28 10:30:44",
        "cnIbraryType": "TN948.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/MGqw45r7n.jpg",
        "topic": "人物短视频运镜一本通：运镜入门+专题实战+后期美颜",
        "title": "人物短视频运镜一本通：运镜入门+专题实战+后期美颜",
        "author": "木白编著",
        "isbn": "9787301345641",
        "publisher": "北京大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4575335,
        "gid": 4575335,
        "goodsType": 1,
        "price": 72.0000,
        "discount": 1,
        "discountPrice": 72.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:07:48",
        "cnIbraryType": "F49",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/O34jYQPN7.jpg",
        "topic": "基于互联网的中国数字经济创新发展研究",
        "title": "基于互联网的中国数字经济创新发展研究",
        "author": "柳西波 张静",
        "isbn": "9787576818789",
        "publisher": "吉林大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4604386,
        "gid": 4604386,
        "goodsType": 1,
        "price": 49.8000,
        "discount": 1,
        "discountPrice": 49.8000,
        "currency": 1,
        "createTime": "2024-08-28 16:19:26",
        "cnIbraryType": "TN948.4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ItQYIcWjo.jpg",
        "topic": "剪映:剪辑+调色+字幕+配音+特效从新手到高手",
        "title": "剪映:剪辑+调色+字幕+配音+特效从新手到高手",
        "author": "王凤英 杜利明 巴图蒙赫",
        "isbn": "9787574220751",
        "publisher": "天津科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4599373,
        "gid": 4599373,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:23:31",
        "cnIbraryType": "TN305.8",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/MZztPKhcA.jpg",
        "topic": "真空镀膜技术与应用",
        "title": "真空镀膜技术与应用",
        "author": "田灿鑫",
        "isbn": "9787562969792",
        "publisher": "武汉理工大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4594639,
        "gid": 4594639,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:23:31",
        "cnIbraryType": "F49",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/k5fx6rsZI.jpg",
        "topic": "平台企业价值创造与价值获取研究 : 模型、机制与实现路径",
        "title": "平台企业价值创造与价值获取研究 : 模型、机制与实现路径",
        "author": "杜华勇",
        "isbn": "9787576824360",
        "publisher": "吉林大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4560252,
        "gid": 4560252,
        "goodsType": 1,
        "price": 95.0000,
        "discount": 1,
        "discountPrice": 95.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:23:32",
        "cnIbraryType": "TN405",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/n56jLYJ4d.jpg",
        "topic": "固体聚合物电解质与金属的阳极键合",
        "title": "固体聚合物电解质与金属的阳极键合",
        "author": "杜超著",
        "isbn": "9787522122694",
        "publisher": "中国原子能出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4574902,
        "gid": 4574902,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-30 10:32:48",
        "cnIbraryType": "TN929.53",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/sPXtSDX8s.jpg",
        "topic": "Flutter和Dart经典实例",
        "title": "Flutter和Dart经典实例",
        "author": "[英]理查德·罗斯(Richard Rose)",
        "isbn": "9787519886271",
        "publisher": "中国电力出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10153": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4524099,
        "gid": 4524099,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:14:34",
        "cnIbraryType": "TP212",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/p6F437NWF.jpg",
        "topic": "多粒度信息融合与应用",
        "title": "多粒度信息融合与应用",
        "author": "李新德",
        "isbn": "9787121467592",
        "publisher": "电子工业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4617633,
        "gid": 4617633,
        "goodsType": 1,
        "price": 69.0000,
        "discount": 1,
        "discountPrice": 69.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:14:34",
        "cnIbraryType": "X820.3",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/zWv9cqJma.jpg",
        "topic": "环境影响评价实践教程",
        "title": "环境影响评价实践教程",
        "author": "赵晓莉",
        "isbn": "9787121478208",
        "publisher": "电子工业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4542511,
        "gid": 4542511,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-26 16:14:36",
        "cnIbraryType": "TP393.0",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/p7cIvXWR6.jpg",
        "topic": "云计算（第四版）",
        "title": "云计算（第四版）",
        "author": "刘鹏",
        "isbn": "9787121471605",
        "publisher": "电子工业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4502282,
        "gid": 4502282,
        "goodsType": 1,
        "price": 59.8000,
        "discount": 1,
        "discountPrice": 59.8000,
        "currency": 1,
        "createTime": "2024-08-29 06:48:27",
        "cnIbraryType": "Q94",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7ginf6jrR.jpg",
        "topic": "植物告诉我们未来",
        "title": "植物告诉我们未来",
        "author": "（意）芭尔芭拉·马佐莱（BARBARA MAZZOLAI",
        "isbn": "9787559132574",
        "publisher": "辽宁科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4431787,
        "gid": 4431787,
        "goodsType": 1,
        "price": 68.0000,
        "discount": 1,
        "discountPrice": 68.0000,
        "currency": 1,
        "createTime": "2024-08-30 13:58:15",
        "cnIbraryType": "T",
        "imageUrl": "http://img1.winxuancdn.com/1590/1203341590_0_0_800x800.jpg?1717644931757",
        "topic": "Lie对称在若干非线性系统中的应用",
        "title": "Lie对称在若干非线性系统中的应用",
        "author": "胡松华, 黎冠,刘德权编著",
        "isbn": "9787576815818",
        "publisher": "吉林大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4545188,
        "gid": 4545188,
        "goodsType": 1,
        "price": 168.0000,
        "discount": 1,
        "discountPrice": 168.0000,
        "currency": 1,
        "createTime": "2024-08-30 16:46:18",
        "cnIbraryType": "Z4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/MoRfXKYEN.jpg",
        "topic": "科学编史学新论",
        "title": "科学编史学新论",
        "author": "刘兵",
        "isbn": "9787313291899",
        "publisher": "上海交通大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4597649,
        "gid": 4597649,
        "goodsType": 1,
        "price": 72.0000,
        "discount": 1,
        "discountPrice": 72.0000,
        "currency": 1,
        "createTime": "2024-09-02 09:52:56",
        "cnIbraryType": "B",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/OHaby7T2i.jpg",
        "topic": "黑噪音、白噪音与幽灵之声",
        "title": "黑噪音、白噪音与幽灵之声",
        "author": "姜宇辉",
        "isbn": "9787532189298",
        "publisher": "上海文艺出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4594660,
        "gid": 4594660,
        "goodsType": 1,
        "price": 120.0000,
        "discount": 1,
        "discountPrice": 120.0000,
        "currency": 1,
        "createTime": "2024-09-02 10:00:16",
        "cnIbraryType": "X",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/vhMTo5M0h.jpg",
        "topic": "环境的科学",
        "title": "环境的科学",
        "author": "［美］威廉?坎宁安（William Cunningham）\n         ［美］玛丽?安?坎宁安（Mary Ann Cunningham）",
        "isbn": "9787573907578",
        "publisher": "浙江科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10155": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4648219,
        "gid": 4648219,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:20:44",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/QBekZold2.jpg",
        "topic": "森林资源保护与管理研究（塑封）",
        "title": "森林资源保护与管理研究（塑封）",
        "author": "钟云华",
        "isbn": "9787203127925",
        "publisher": "山西人民出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4578325,
        "gid": 4578325,
        "goodsType": 1,
        "price": 72.0000,
        "discount": 1,
        "discountPrice": 72.0000,
        "currency": 1,
        "createTime": "2024-08-30 14:50:23",
        "cnIbraryType": "S31",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/SEsFP0KRh.jpg",
        "topic": "农作物生产技术",
        "title": "农作物生产技术",
        "author": "杨强学，孔泽华，赵展著",
        "isbn": "9787568711593",
        "publisher": "湘潭大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4629888,
        "gid": 4629888,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-30 14:50:25",
        "cnIbraryType": "S-01",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/jmdeJhMIc.jpg",
        "topic": "农户绿色生产技术的初次采用与持续性行为研究",
        "title": "农户绿色生产技术的初次采用与持续性行为研究",
        "author": "余威震，罗小锋著",
        "isbn": "9787109319042",
        "publisher": "中国农业出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4590992,
        "gid": 4590992,
        "goodsType": 1,
        "price": 72.0000,
        "discount": 1,
        "discountPrice": 72.0000,
        "currency": 1,
        "createTime": "2024-08-30 15:22:31",
        "cnIbraryType": "",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/aXyUmJnaJ.jpg",
        "topic": "园林生态化建设与植物育种学",
        "title": "园林生态化建设与植物育种学",
        "author": "",
        "isbn": "9787574409095",
        "publisher": "吉林科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4639385,
        "gid": 4639385,
        "goodsType": 1,
        "price": 128.0000,
        "discount": 1,
        "discountPrice": 128.0000,
        "currency": 1,
        "createTime": "2024-08-30 16:46:18",
        "cnIbraryType": "S6",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Q9GCzr4Rk.jpg",
        "topic": "南洋花木——上海交通大学观赏树木图鉴（中英双语）",
        "title": "南洋花木——上海交通大学观赏树木图鉴（中英双语）",
        "author": "张荻",
        "isbn": "9787313186027",
        "publisher": "上海交通大学出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4531634,
        "gid": 4531634,
        "goodsType": 1,
        "price": 58.0000,
        "discount": 1,
        "discountPrice": 58.0000,
        "currency": 1,
        "createTime": "2024-08-30 16:51:26",
        "cnIbraryType": "D6",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/I621V2EcT.jpg",
        "topic": "绿色奇迹塞罕坝",
        "title": "绿色奇迹塞罕坝",
        "author": "刘燕",
        "isbn": "9787511577993",
        "publisher": "人民日报出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4598738,
        "gid": 4598738,
        "goodsType": 1,
        "price": 128.0000,
        "discount": 1,
        "discountPrice": 128.0000,
        "currency": 1,
        "createTime": "2024-09-02 10:06:56",
        "cnIbraryType": "X",
        "imageUrl": "http://img0.winxuancdn.com/8569/1203338569_0_1_800x800.jpg?1717578470245",
        "topic": "林草碳汇",
        "title": "林草碳汇",
        "author": "李芳 主编",
        "isbn": "9787547866207",
        "publisher": "上海科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4616025,
        "gid": 4616025,
        "goodsType": 1,
        "price": 100.0000,
        "discount": 1,
        "discountPrice": 100.0000,
        "currency": 1,
        "createTime": "2024-09-02 10:06:57",
        "cnIbraryType": "S",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/BScYhpJYk.jpg",
        "topic": "花生连作障碍机理及消减技术",
        "title": "花生连作障碍机理及消减技术",
        "author": "万书波 郭峰 等 著",
        "isbn": "9787547866313",
        "publisher": "上海科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10156": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4652587,
        "gid": 4652587,
        "goodsType": 1,
        "price": 280.0000,
        "discount": 1,
        "discountPrice": 280.0000,
        "currency": 1,
        "createTime": "2024-08-27 09:30:08",
        "cnIbraryType": "R656",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/voZpwINHP.jpg",
        "topic": "消化道手术及内镜创新技术",
        "title": "消化道手术及内镜创新技术",
        "author": "",
        "isbn": "9787543344624",
        "publisher": "天津科技翻译出版有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4652591,
        "gid": 4652591,
        "goodsType": 1,
        "price": 58.0000,
        "discount": 1,
        "discountPrice": 58.0000,
        "currency": 1,
        "createTime": "2024-08-27 09:30:08",
        "cnIbraryType": "R54",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/GZ0nYD6Wj.jpg",
        "topic": "心屋修缮：让心脏更健康",
        "title": "心屋修缮：让心脏更健康",
        "author": "",
        "isbn": "9787543343788",
        "publisher": "天津科技翻译出版有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4616770,
        "gid": 4616770,
        "goodsType": 1,
        "price": 68.0000,
        "discount": 1,
        "discountPrice": 68.0000,
        "currency": 1,
        "createTime": "2024-08-27 09:30:08",
        "cnIbraryType": "R655.1",
        "imageUrl": "http://img0.winxuancdn.com/6312/1203336312_0_1_800x800.jpg?1717406220444",
        "topic": "胸壁畸形外科手术",
        "title": "胸壁畸形外科手术",
        "author": "",
        "isbn": "9787543344495",
        "publisher": "天津科技翻译出版有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4609737,
        "gid": 4609737,
        "goodsType": 1,
        "price": 168.0000,
        "discount": 1,
        "discountPrice": 168.0000,
        "currency": 1,
        "createTime": "2024-08-27 09:30:08",
        "cnIbraryType": "R572",
        "imageUrl": "http://img3.winxuancdn.com/4644/1203334644_0_1_800x800.jpg?1717471056592",
        "topic": "腹部影像学：核心必读",
        "title": "腹部影像学：核心必读",
        "author": "",
        "isbn": "9787543344396",
        "publisher": "天津科技翻译出版有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4566906,
        "gid": 4566906,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-27 09:30:08",
        "cnIbraryType": "R681.5",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/VGPosRk1A.jpg",
        "topic": "微创脊柱外科技术",
        "title": "微创脊柱外科技术",
        "author": "",
        "isbn": "9787543344129",
        "publisher": "天津科技翻译出版有限公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4432913,
        "gid": 4432913,
        "goodsType": 1,
        "price": 218.0000,
        "discount": 1,
        "discountPrice": 218.0000,
        "currency": 1,
        "createTime": "2024-08-29 06:48:27",
        "cnIbraryType": "R681.5",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/rAevoKZ1c.jpg",
        "topic": "脊柱感染的影像学诊断",
        "title": "脊柱感染的影像学诊断",
        "author": "（突）穆罕默德·费提·拉德布（Mohamed Fe",
        "isbn": "9787559130471",
        "publisher": "辽宁科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4437445,
        "gid": 4437445,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-29 06:48:27",
        "cnIbraryType": "R249",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/2QZi1PZ9e.jpg",
        "topic": "针灸临床经典用穴荟萃",
        "title": "针灸临床经典用穴荟萃",
        "author": "杨朝义",
        "isbn": "9787559130808",
        "publisher": "辽宁科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4555510,
        "gid": 4555510,
        "goodsType": 1,
        "price": 328.0000,
        "discount": 1,
        "discountPrice": 328.0000,
        "currency": 1,
        "createTime": "2024-08-29 06:48:27",
        "cnIbraryType": "R681.3",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/snoRIdZjc.jpg",
        "topic": "膝关节软骨",
        "title": "膝关节软骨",
        "author": "（加拿大）哈帕尔·K.加胡尼亚（Harpal K.G",
        "isbn": "9787559132093",
        "publisher": "辽宁科学技术出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10157": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4499335,
        "gid": 4499335,
        "goodsType": 1,
        "price": 54.0000,
        "discount": 1,
        "discountPrice": 54.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "F715",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/NSG7UiNun.jpg",
        "topic": "持续增长:松下幸之助的经营心得（DSHF）",
        "title": "持续增长:松下幸之助的经营心得（DSHF）",
        "author": "[日]松下幸之助",
        "isbn": "9787520735285",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4499338,
        "gid": 4499338,
        "goodsType": 1,
        "price": 54.0000,
        "discount": 1,
        "discountPrice": 54.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "F715",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/zyaA7Te7x.jpg",
        "topic": "经营诀窍:松下幸之助的“成功捷径”（DSHF）",
        "title": "经营诀窍:松下幸之助的“成功捷径”（DSHF）",
        "author": "[日]松下幸之助",
        "isbn": "9787520736022",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4499340,
        "gid": 4499340,
        "goodsType": 1,
        "price": 54.0000,
        "discount": 1,
        "discountPrice": 54.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "F4",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/O3l89ihAc.jpg",
        "topic": "经营哲学:松下幸之助的20条实践心得（DSHF）",
        "title": "经营哲学:松下幸之助的20条实践心得（DSHF）",
        "author": "[日]松下幸之助",
        "isbn": "9787520735858",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4591698,
        "gid": 4591698,
        "goodsType": 1,
        "price": 88.0000,
        "discount": 1,
        "discountPrice": 88.0000,
        "currency": 1,
        "createTime": "2024-08-27 17:08:50",
        "cnIbraryType": "F729",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/1GRuBwPQu.jpg",
        "topic": "商者",
        "title": "商者",
        "author": "臧长风",
        "isbn": "9787520730860",
        "publisher": "东方出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4591975,
        "gid": 4591975,
        "goodsType": 1,
        "price": 49.8000,
        "discount": 1,
        "discountPrice": 49.8000,
        "currency": 1,
        "createTime": "2024-08-30 14:42:22",
        "cnIbraryType": "F0",
        "imageUrl": "http://img3.winxuancdn.com/8850/1203318850_0_1_800x800.jpg?1716518014715",
        "topic": "反套路经济学：那些危言耸听的悖论",
        "title": "反套路经济学：那些危言耸听的悖论",
        "author": "[美]史蒂夫?兰兹伯格/著 吕恺迪/译",
        "isbn": "9787559675293",
        "publisher": "北京联合出版公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4589862,
        "gid": 4589862,
        "goodsType": 1,
        "price": 49.8000,
        "discount": 1,
        "discountPrice": 49.8000,
        "currency": 1,
        "createTime": "2024-08-30 14:42:22",
        "cnIbraryType": "F0",
        "imageUrl": "http://img2.winxuancdn.com/2104/1203312104_0_1_800x800.jpg?1714964197885",
        "topic": "反套路经济学：为什么常识会撒谎？",
        "title": "反套路经济学：为什么常识会撒谎？",
        "author": "[美]史蒂夫?兰兹伯格/著 王艺璇/译",
        "isbn": "9787559674883",
        "publisher": "北京联合出版公司",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4546025,
        "gid": 4546025,
        "goodsType": 1,
        "price": 59.0000,
        "discount": 1,
        "discountPrice": 59.0000,
        "currency": 1,
        "createTime": "2024-08-30 14:50:24",
        "cnIbraryType": "F419",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/nHJTeG987.jpg",
        "topic": "工业革命",
        "title": "工业革命",
        "author": "（英）罗伯特·C.艾伦（Robert C.Allen）著",
        "isbn": "9787544799713",
        "publisher": "译林出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4613513,
        "gid": 4613513,
        "goodsType": 1,
        "price": 59.9000,
        "discount": 1,
        "discountPrice": 59.9000,
        "currency": 1,
        "createTime": "2024-08-30 15:35:32",
        "cnIbraryType": "F0",
        "imageUrl": "http://img3.winxuancdn.com/4391/1203334391_0_0_800x800.jpg?1720160214912",
        "topic": "成为更理性的人：经济学就是权衡取舍",
        "title": "成为更理性的人：经济学就是权衡取舍",
        "author": "方钦",
        "isbn": "9787573015525",
        "publisher": "海南出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "10159": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records": [{
        "goodsId": 4470773,
        "gid": 4470773,
        "goodsType": 1,
        "price": 95.0000,
        "discount": 1,
        "discountPrice": 95.0000,
        "currency": 1,
        "createTime": "2024-08-28 15:35:03",
        "cnIbraryType": "A81",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/hpEKuQD62.jpg",
        "topic": "《马克思主义基本原理》教学案例选编",
        "title": "《马克思主义基本原理》教学案例选编",
        "author": "张彬，傅晓",
        "isbn": "9787522511160",
        "publisher": "九州出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4610765,
        "gid": 4610765,
        "goodsType": 1,
        "price": 95.0000,
        "discount": 1,
        "discountPrice": 95.0000,
        "currency": 1,
        "createTime": "2024-08-28 15:35:04",
        "cnIbraryType": "A81",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/sPwLNSaXa.jpg",
        "topic": "马克思主义基本原理小专题教学讲义",
        "title": "马克思主义基本原理小专题教学讲义",
        "author": "金雪飞",
        "isbn": "9787522526331",
        "publisher": "九州出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4634322,
        "gid": 4634322,
        "goodsType": 1,
        "price": 98.0000,
        "discount": 1,
        "discountPrice": 98.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:56:03",
        "cnIbraryType": "A811.6",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/AaYPWhp2R.jpg",
        "topic": "文本与时代：马克思“世界历史”思想研究",
        "title": "文本与时代：马克思“世界历史”思想研究",
        "author": "周康林 著",
        "isbn": "9787522837840",
        "publisher": "社会科学文献出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4588388,
        "gid": 4588388,
        "goodsType": 1,
        "price": 128.0000,
        "discount": 1,
        "discountPrice": 128.0000,
        "currency": 1,
        "createTime": "2024-08-28 16:56:03",
        "cnIbraryType": "A811.2",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ggVIxcrY7.jpg",
        "topic": "《神圣家族》与历史唯物主义的形成",
        "title": "《神圣家族》与历史唯物主义的形成",
        "author": "任帅军著",
        "isbn": "9787522834412",
        "publisher": "社会科学文献出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4544336,
        "gid": 4544336,
        "goodsType": 1,
        "price": 148.0000,
        "discount": 1,
        "discountPrice": 148.0000,
        "currency": 1,
        "createTime": "2024-08-29 16:15:43",
        "cnIbraryType": "A124",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Q4KQgvJio.jpg",
        "topic": "《反杜林论》英文版伯恩斯译本考",
        "title": "《反杜林论》英文版伯恩斯译本考",
        "author": "熊成帅",
        "isbn": "9787205109455",
        "publisher": "辽宁人民出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4617083,
        "gid": 4617083,
        "goodsType": 1,
        "price": 48.0000,
        "discount": 1,
        "discountPrice": 48.0000,
        "currency": 1,
        "createTime": "2024-08-30 09:00:13",
        "cnIbraryType": "A841.2",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ClvMOhTk4.jpg",
        "topic": "毛泽东经典著作研读系列丛书：《在延安文艺座谈会上的讲话》研读",
        "title": "毛泽东经典著作研读系列丛书：《在延安文艺座谈会上的讲话》研读",
        "author": "宋修见 著",
        "isbn": "9787519916527",
        "publisher": "研究出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4617082,
        "gid": 4617082,
        "goodsType": 1,
        "price": 58.0000,
        "discount": 1,
        "discountPrice": 58.0000,
        "currency": 1,
        "createTime": "2024-08-30 09:00:13",
        "cnIbraryType": "A841",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/vyh9VSwqu.jpg",
        "topic": "毛泽东经典著作研读系列丛书：《改造我们的学习》研读",
        "title": "毛泽东经典著作研读系列丛书：《改造我们的学习》研读",
        "author": "吴波   著",
        "isbn": "9787519916442",
        "publisher": "研究出版社",
        "selectNum": 0,
        "allNum": 0
      }, {
        "goodsId": 4500240,
        "gid": 4500240,
        "goodsType": 1,
        "price": 58.0000,
        "discount": 1,
        "discountPrice": 58.0000,
        "currency": 1,
        "createTime": "2024-08-30 09:00:13",
        "cnIbraryType": "A8",
        "imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/b2MIIyPh1.jpg",
        "topic": "马克思主义中国化与传统文化现代化系列丛书:马克思主义中国化经典著作选读",
        "title": "马克思主义中国化与传统文化现代化系列丛书:马克思主义中国化经典著作选读",
        "author": "崔存明 总主编  郧在廷  张欣 主编",
        "isbn": "9787519915735",
        "publisher": "研究出版社",
        "selectNum": 0,
        "allNum": 0
      }]
    }
  },
  "51": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records":[
        {
            "gid": "108454",
             "goodsId": "108454",
            "imageUrl": "http://cover.yuntu.io/69/41/9787111242819.jpg",
            "title": "Java Web整合开发完全自学手册"
        },
        {
            "gid": "620143",
             "goodsId": "620143",
            "imageUrl": "http://cover.yuntu.io/71/87/9787307089167.jpg",
            "title": "大学英语四级高阶教程"
        },
        {
            "gid": "1491146",
             "goodsId": "1491146",
            "imageUrl": "http://cover.yuntu.io/68/68/9787030170200.jpg",
            "title": "新题型大学英语四级王牌"
        },
        {
            "gid": "1481647",
             "goodsId": "1481647",
            "imageUrl": "http://cover.yuntu.io/76/47/9787806848739.jpg",
            "title": "大学英语四级完形与翻译"
        },
        {
            "gid": "1298143",
             "goodsId": "1298143",
            "imageUrl": "http://cover.yuntu.io/68/77/9787030278883.jpg",
            "title": "新托业完全攻略"
        },
        {
            "gid": "315508",
             "goodsId": "315508",
            "imageUrl": "http://cover.yuntu.io/69/75/9787111277477.jpg",
            "title": "卢峭梅讲雅思听力机经"
        },
        {
            "gid": "2256418",
             "goodsId": "2256418",
            "imageUrl": "http://cover.yuntu.io/71/0/9787300200101.jpg",
            "title": "雅思12句口语法"
        },
        {
            "gid": "628086",
             "goodsId": "628086",
            "imageUrl": "http://cover.yuntu.io/71/31/9787300132723.jpg",
            "title": "功课雅思28天黄金法则"
        }
    ]
    }
  },
  "52": {
    "status": true,
    "code": "200",
    "msg": "success",
    "errorMsg": "",
    "data": {
      "total": 0,
      "size": 8,
      "pages": 0,
      "current": 1,
      "records":[
        {
            "gid": "108454",
             "goodsId": "108454",
            "imageUrl": "http://cover.yuntu.io/69/41/9787111242819.jpg",
            "title": "Java Web整合开发完全自学手册"
        },
        {
            "gid": "620143",
             "goodsId": "620143",
            "imageUrl": "http://cover.yuntu.io/71/87/9787307089167.jpg",
            "title": "大学英语四级高阶教程"
        },
        {
            "gid": "1491146",
             "goodsId": "1491146",
            "imageUrl": "http://cover.yuntu.io/68/68/9787030170200.jpg",
            "title": "新题型大学英语四级王牌"
        },
        {
            "gid": "1481647",
             "goodsId": "1481647",
            "imageUrl": "http://cover.yuntu.io/76/47/9787806848739.jpg",
            "title": "大学英语四级完形与翻译"
        },
        {
            "gid": "1298143",
             "goodsId": "1298143",
            "imageUrl": "http://cover.yuntu.io/68/77/9787030278883.jpg",
            "title": "新托业完全攻略"
        },
        {
            "gid": "315508",
             "goodsId": "315508",
            "imageUrl": "http://cover.yuntu.io/69/75/9787111277477.jpg",
            "title": "卢峭梅讲雅思听力机经"
        },
        {
            "gid": "2256418",
             "goodsId": "2256418",
            "imageUrl": "http://cover.yuntu.io/71/0/9787300200101.jpg",
            "title": "雅思12句口语法"
        },
        {
            "gid": "628086",
             "goodsId": "628086",
            "imageUrl": "http://cover.yuntu.io/71/31/9787300132723.jpg",
            "title": "功课雅思28天黄金法则"
        }
    ]
    }
  },
}



// WEBPACK FOOTER //
// ./src/dataJson/bookData.js